import { isAfter, isBefore } from '@sequencehq/utils/dates'
import { useBillingScheduleAggregate } from 'BillingScheduleHome/utils/useBillingScheduleAggregate'

export const useCurrentPhaseHasInAdvancePrices = (props: {
  billingScheduleId: string
}) => {
  const billingScheduleAggregateQuery = useBillingScheduleAggregate({
    billingScheduleId: props.billingScheduleId,
    select: data => {
      const today = new Date()

      const currentPhase = data.billingSchedule.phases.find(phase => {
        return (
          isAfter(today, phase.startDate) &&
          (!phase.endDate || isBefore(today, phase.endDate))
        )
      })

      if (!currentPhase) {
        return {
          currentPhaseHasInAdvancePrices: false
        }
      }

      const currentPrices = currentPhase.priceIds.map(priceId =>
        data.prices.find(price => price.id === priceId)
      )

      return {
        currentPhaseHasInAdvancePrices: currentPrices.some(
          price => price?.billingType === 'IN_ADVANCE'
        )
      }
    }
  })

  return {
    isLoading: billingScheduleAggregateQuery.isPending,
    currentPhaseHasInAdvancePrices: Boolean(
      billingScheduleAggregateQuery.data?.currentPhaseHasInAdvancePrices
    )
  }
}
